import { serviceQuestionViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    activeIndex: 0
}

export default function serviceQuestionViewerSlice(state = initialState, action) {
    switch (action.type) {
        case serviceQuestionViewerSliceDispatch.setActiveIndex: {
            return {
                ...state,
                activeIndex: action.payload
            }
        }
        default:
            return state
    }
}
